var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center justify-center w-full h-full"},[_c('svg',{attrs:{"id":"indicator","viewBox":"0 0 100 100"}},[_c('circle',{attrs:{"id":"circle","cx":"50","cy":"50","r":"45"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }